/**
 * The ranking formulas' metric catalog — the Flow Optimizer's WHOLE formula
 * catalog (traffic, conversions, money, rates, advanced), in its ids and
 * units — and how a metric's value prints. The plain-words line under a
 * formula is gone (23/10/2026, client QA: "Lets hide this option").
 * For Media Devoted | Created By Ciro Autiero
 */
import {
  FLOW_FORMULA_METRICS,
  type FlowOptimizerMetricMeta,
} from '@trafficpulse/shared';

export const HOUR_METRIC_CATALOG: FlowOptimizerMetricMeta[] = FLOW_FORMULA_METRICS;

const PERCENT = new Set(['roi', 'ctr', 'cr', 'cv', 'uctr', 'ucr']);
const COUNT = new Set(['impressions', 'visits', 'uniqueVisits', 'clicks', 'uniqueClicks', 'conversions', 'registrations', 'ftd']);

/** A metric value the way the Flow Optimizer prints it: counts whole, rates in %, money 2–4 decimals. */
export function formatMetric(id: string, v: number): string {
  if (COUNT.has(id)) return Math.round(v).toLocaleString('en-US');
  if (PERCENT.has(id)) return `${v.toLocaleString('en-US', { maximumFractionDigits: 2 })}%`;
  const decimals = Math.abs(v) > 0 && Math.abs(v) < 0.01 ? 4 : 2;
  return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: decimals });
}

export const CATEGORY_LABEL: Record<string, string> = {
  traffic: 'Traffic',
  conversions: 'Conversions',
  financial: 'Money',
  rates: 'Rates',
  advanced: 'Advanced',
};
